
<template>
  <div class="modal modal-blur fade" id="modal-job-progress" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{jobTitle}} Progress</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z"/><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
          </button>
        </div>
        <div class="modal-body">
          {{stage}} {{percentage}}%
        </div>
        <div class="modal-footer" v-if="pdf">
          <p>IMPORTANT: Please review the PDF before sending to the client. You can open the PDF in a new tab, close the tab, and save to downloads without losing your progress. Thank You.</p>
          <select v-model="saveType">
            <option value="newTab">Open in new tab to review (Recommended)</option>
            <option value="file">Save to Downloads</option>
          </select>
          <button @click.prevent="savePdf" class="btn btn-primary">Save PDF</button>
        </div>
      </div>
    </div>
  </div>
</template>



<script>
  import { saveAs } from 'file-saver';
  
  export default {
    data() {
      return {
        saveType: "newTab"
      };
    },
    
    props: {
      jobTitle: String,
      stage: String,
      percentage: Number,
      pdf: Object
    },
    
    methods: {
      savePdf() {
        if(this.saveType == "newTab") {
          const blobURL = URL.createObjectURL(this.pdf.pdf);
          
          window.open(blobURL, "_blank");
          
          setTimeout(() => { window.URL.revokeObjectURL(blobURL); }, 30000);
        }
        else {
          saveAs(this.pdf.pdf, this.pdf.filename);
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/ProgressDlg.vue